if not App.angularApp?
    return

App.angularApp.directive 'mfClickOutside', ['$document', ($document) ->
    return {
        restrict: 'A'
        link: (scope, ele, attrs) ->

            # prevent closing when clicking on element
            ele.bind 'click', (e) =>
                e.stopPropagation()

            # close when clicking anywhere but input[file]
            $document.bind 'click', (e) =>
                # if the current scope is already open
                if (scope.isOpen? and scope.isOpen) or not scope.isOpen?

                    # input[file][checkbox] will not work properly if we use scope.$apply
                    # solution is to ignore if we clicked on an input or its label but only
                    if not (angular.element(e.target).is('input') or angular.element(e.target).is('label'))
                        scope.$apply(attrs.mfClickOutside)
    }
]
